<script>
  export let classes;
</script>

<div class={classes}>
  <svg
    class="h-full w-full"
    width="100%"
    height="100%"
    viewBox="0 0 123 111"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_5244_6528)">
      <rect
        x="19.727"
        y="2.31242"
        width="103"
        height="88"
        rx="2.88835"
        transform="rotate(11.231 19.727 2.31242)"
        stroke="#F9F9F9"
        shape-rendering="crispEdges"
      />
    </g>
    <g filter="url(#filter1_d_5244_6528)">
      <rect
        x="14.1152"
        y="6.2793"
        width="104"
        height="89"
        rx="3.38835"
        transform="rotate(5.42958 14.1152 6.2793)"
        fill="#F9F9F9"
      />
      <rect
        x="14.5657"
        y="6.82436"
        width="103"
        height="88"
        rx="2.88835"
        transform="rotate(5.42958 14.5657 6.82436)"
        stroke="#F9F9F9"
      />
    </g>
    <g filter="url(#filter2_d_5244_6528)">
      <rect
        x="9.67188"
        y="11"
        width="104"
        height="89"
        rx="3.38835"
        fill="#F9F9F9"
      />
      <rect
        x="10.1719"
        y="11.5"
        width="103"
        height="88"
        rx="2.88835"
        stroke="#F9F9F9"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_5244_6528"
        x="0.594238"
        y="0.318848"
        width="122.154"
        height="110.363"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5244_6528"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5244_6528"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_5244_6528"
        x="3.99902"
        y="4.58447"
        width="115.344"
        height="101.831"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5244_6528"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5244_6528"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_5244_6528"
        x="7.67188"
        y="9"
        width="108"
        height="93"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5244_6528"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5244_6528"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</div>
